import { QuestionResponse } from 'types/question-response.types';

export const OTHER_OPTION = '__other_option_value' as const;

export enum IsRequired {
  Req = 'Req',
  Opt = 'Opt'
}

/**
 * @description type constructor for form-compliant versions
 * of the QuestionResponse types.
 * - Makes the type and req fields mandatory
 * - Removes the id field
 * - The keys passed to the constructor become optional so that
 *   the type can be used in empty forms
 *
 * @example type BaseLongQuestionResponseFormValue = QuestionResponseFormValue<LongQuestionResponse, 'value'>;
 * @description LongQuestionResponse.value is the field where response text is saved so that field is passed in the K argument to make it optional
 */
export type QuestionResponseFormValue<T extends QuestionResponse, K extends keyof T> = Pick<
  T,
  'type'
> &
  Omit<T, 'id' | 'type' | K> &
  Partial<Pick<T, K>> & { req: IsRequired };
